// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SmallErrorText {
  height: 30px;
  left: 340px;
  right: 340px;
  top: 168px;
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 30px;
  /* identical to box height, or 187% */
  color: #959698;
}

.LargeErrorText {
  height: 48px;
  left: 340px;
  right: 340px;
  top: 547px;
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: 600;
  font-size: 48px;
  line-height: 48px;
  /* identical to box height, or 100% */
}

.StandardErrorText {
  height: 78px;
  left: 340px;
  right: 340px;
  top: 618px;
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 16.5px;
  line-height: 26px;
  /* or 158% */
  /* mono/\$mono-dark */
  color: #2C2A38;
}

.HelpDesk {
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: 600;
  font-size: 16.5px;
  line-height: 24px;
  /* identical to box height, or 145% */
  display: flex;
  align-items: center;
  text-align: center;
  text-decoration-line: underline;
  color: #00B9FF;
}`, "",{"version":3,"sources":["webpack://./src/app/error/error.component.scss","webpack://./../../01.%20UI/NgHsSurveyClient/src/app/error/error.component.scss"],"names":[],"mappings":"AAAA;EAEI,YAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EAEA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EAGA,cAAA;ACHJ;;ADMA;EAEI,YAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EAEA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;ACLJ;;ADSA;EAEI,YAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EAEA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EAGA,oBAAA;EAEA,cAAA;ACXJ;;ADcA;EAEI,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,qCAAA;EAEA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,+BAAA;EAEA,cAAA;ACdJ","sourcesContent":[".SmallErrorText\r\n{\r\n    height: 30px;\r\n    left: 340px;\r\n    right: 340px;\r\n    top: 168px;\r\n\r\n    font-family: Source Sans Pro;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    font-size: 16px;\r\n    line-height: 30px;\r\n    /* identical to box height, or 187% */\r\n\r\n\r\n    color: #959698;\r\n}\r\n\r\n.LargeErrorText\r\n{\r\n    height: 48px;\r\n    left: 340px;\r\n    right: 340px;\r\n    top: 547px;\r\n\r\n    font-family: Source Sans Pro;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    font-size: 48px;\r\n    line-height: 48px;\r\n    /* identical to box height, or 100% */\r\n\r\n}\r\n\r\n.StandardErrorText\r\n{\r\n    height: 78px;\r\n    left: 340px;\r\n    right: 340px;\r\n    top: 618px;\r\n\r\n    font-family: Source Sans Pro;\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    font-size: 16.5px;\r\n    line-height: 26px;\r\n    /* or 158% */\r\n\r\n\r\n    /* mono/$mono-dark */\r\n\r\n    color: #2C2A38;\r\n}\r\n\r\n.HelpDesk\r\n{\r\n    font-family: Source Sans Pro;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    font-size: 16.5px;\r\n    line-height: 24px;\r\n    /* identical to box height, or 145% */\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n    text-decoration-line: underline;\r\n\r\n    color: #00B9FF;\r\n}\r\n",".SmallErrorText {\n  height: 30px;\n  left: 340px;\n  right: 340px;\n  top: 168px;\n  font-family: Source Sans Pro;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 30px;\n  /* identical to box height, or 187% */\n  color: #959698;\n}\n\n.LargeErrorText {\n  height: 48px;\n  left: 340px;\n  right: 340px;\n  top: 547px;\n  font-family: Source Sans Pro;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 48px;\n  line-height: 48px;\n  /* identical to box height, or 100% */\n}\n\n.StandardErrorText {\n  height: 78px;\n  left: 340px;\n  right: 340px;\n  top: 618px;\n  font-family: Source Sans Pro;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16.5px;\n  line-height: 26px;\n  /* or 158% */\n  /* mono/$mono-dark */\n  color: #2C2A38;\n}\n\n.HelpDesk {\n  font-family: Source Sans Pro;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16.5px;\n  line-height: 24px;\n  /* identical to box height, or 145% */\n  display: flex;\n  align-items: center;\n  text-align: center;\n  text-decoration-line: underline;\n  color: #00B9FF;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
